import React from 'react';

function ArrowLeft(props) {
  const disabeld = props.disabled ? " arrow--disabled" : ""
  return (
    <div className={"group relative cursor-pointer w-24"}>
      <svg
        onClick={props.onClick}
        className={`${props.sliderItems && 'group-hover:invisible'} ' visible absolute top-0 arrow--left'` + disabeld}
        width="32" height="25" xmlns="http://www.w3.org/2000/svg">
        <g className={''} fill="#CFCFCF" fillRule="evenodd">
          <path d="m.005 12.355 2.662-2.662 11.892 11.893-2.662 2.662z" />
          <path d="M2.667 15.024.005 12.362 11.897.469l2.662 2.662z" />
          <path d="M5.163 14.233v-3.765h25.974v3.765z" />
        </g>
      </svg>

      <svg
        onClick={props.onClick}
        className={`${props.sliderItems && 'group-hover:visible'} ' invisible absolute top-0 arrow arrow--left'` + disabeld}
        width="32" height="25" xmlns="http://www.w3.org/2000/svg"
        transform="rotate(-180)">
        <g fillRule="evenodd">
          <path d="m31.495 12.645-2.662 2.662L16.941 3.414 19.603.752z" />
          <path d="m28.833 9.976 2.662 2.662-11.892 11.893-2.662-2.662z" />
          <path d="M26.337 10.767v3.765H.363v-3.765z" />
        </g>
      </svg>
    </div>
  )
}

function ArrowRight(props) {
  const disabeld = props.disabled ? " arrow--disabled" : ""
  return (
    <div className={"group relative cursor-pointer w-20"}>
      <svg
        onClick={props.onClick}
        className={`${props.sliderItems && 'group-hover:invisible'} ' absolute top-0 visible arrow arrow--left'` + disabeld}
        width="32" height="25" xmlns="http://www.w3.org/2000/svg"
        transform="rotate(180)" >
        <g fill="#CFCFCF" fillRule="evenodd">
          <path d="m.005 12.355 2.662-2.662 11.892 11.893-2.662 2.662z" />
          <path d="M2.667 15.024.005 12.362 11.897.469l2.662 2.662z" />
          <path d="M5.163 14.233v-3.765h25.974v3.765z" />
        </g>
      </svg>

      <svg
        onClick={props.onClick}
        className={`${props.sliderItems && 'group-hover:visible'} ' absolute top-0 invisible arrow arrow--left'` + disabeld}
        width="32" height="25" xmlns="http://www.w3.org/2000/svg">
        <g fillRule="evenodd">
          <path d="m31.495 12.645-2.662 2.662L16.941 3.414 19.603.752z" />
          <path d="m28.833 9.976 2.662 2.662-11.892 11.893-2.662-2.662z" />
          <path d="M26.337 10.767v3.765H.363v-3.765z" />
        </g>
      </svg>
    </div>
  )
}

export const NavSlides = ({ sliderItems, currentSlide, slider}) => {
  return (
    <div className={'absolute right-1.5 -top-1.5 w-24 flex justify-between'}>
      <ArrowLeft
        onClick={(e) => e.stopPropagation() || slider.prev()}
        disabled={currentSlide === 0}
        sliderItems={sliderItems}
      />
      <ArrowRight
        onClick={(e) => e.stopPropagation() || slider.next()}
        disabled={currentSlide === slider.details().size - 1}
        sliderItems={sliderItems}
      />
    </div>
  );
};